import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatTabLink, MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { SearchbarComponent } from '../../../common/components/searchbar/searchbar.component';
import { OrgUserListTestIds } from '../org-user-list/org-user-list.test-ids';
import { OrgOidcUsersTestIds } from '../org-oidc-user-list.component/org-oidc-users.test-ids';

interface TabConfig {
  label: string;
  path: string;
}

@Component({
  selector: 'app-org-general-user-list',
  imports: [RouterOutlet, MatTabNav, MatTabLink, RouterLink, RouterLinkActive, MatTabNavPanel, SearchbarComponent],
  templateUrl: './org-general-user-list.component.html',
  styleUrl: 'org-general-user-list.component.scss'
})
/**
 * Verwaltung der Synapse-Nutzerverwaltung und der Keycloak-Nutzerverwaltung.
 */
export class OrgGeneralUserListComponent {
  tabs: TabConfig[];

  searchTerm = signal('');

  private readonly route = inject(ActivatedRoute);

  constructor() {
    this.tabs = this.route.snapshot.data['tabs'];
  }

  protected readonly oidcTestIds = OrgOidcUsersTestIds;
  protected readonly userTestIds = OrgUserListTestIds;

  onSearchChange(searchTerm: string): void {
    this.searchTerm.set(searchTerm);
  }
}
